import React from "react";
import { FaLinkedin } from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="bg-gray-200 text-gray-700 py-4 mt-16 h-96">
      <div className="flex justify-center space-x-20 mt-14">
        <section>
          <h4 className="font-bold pb-8 text-[#7a3432] drop-shadow-lg">
            GET IN TOUCH
          </h4>
          <p className="w-96 text-sm text-gray-500 mb-8">
            Any questions? Let us know, Germany,Heidelburg or call us on (+49)
            96 716 6879
          </p>
          <div className=" py-4 flex items-center">
            <div className="flex items-center space-x-4">
              {/* <a href="#" className="text-black hover:text-gray-400">
                <FaLinkedin size={18} style={{ marginRight: "5px" }} />
              </a> */}
            </div>
          </div>
        </section>

        <section>
          <section class="flex space-x-9">
            <div class="flex-shrink-0">
              <h4 class="font-bold pb-8 text-[#7a3432] drop-shadow-lg">
                CATEGORIES
              </h4>
              <ul class="text-sm text-gray-500 mb-8">
                <li class="pb-4">
                  <a href="#" class="">
                    Assets
                  </a>
                </li>
                <li class="pb-4">
                  <a href="#" class="">
                    Power Systems
                  </a>
                </li>
                <li class="pb-4">
                  <a href="#" class="">
                    Market
                  </a>
                </li>
                <li class="pb-4">
                  <a href="#" class="">
                    Project
                  </a>
                </li>
              </ul>
            </div>
            <div class="flex-shrink-0">
              <h4 class="font-bold pb-8 text-[#7a3432] drop-shadow-lg">
                LINKS
              </h4>
              <ul class="text-sm text-gray-500 mb-8">
                <li class="pb-4">
                  <a href="#" class="">
                    Search
                  </a>
                </li>
                <li class="pb-4">
                  <a href="#" class="">
                    About Us
                  </a>
                </li>
                <li class="pb-4">
                  <a href="#" class="">
                    Contact Us
                  </a>
                </li>
                <li class="pb-4">
                  <a href="#" class="">
                    Returns
                  </a>
                </li>
              </ul>
            </div>
            <div class="flex-shrink-0">
              <h4 class="font-bold pb-8 text-[#7a3432] drop-shadow-lg">HELP</h4>
              <ul class="text-sm text-gray-500 mb-8">
                <li class="pb-4">
                  <a href="#" class="">
                    Track Order
                  </a>
                </li>
                <li class="pb-4">
                  <a href="#" class="">
                    Returns
                  </a>
                </li>
                <li class="pb-4">
                  <a href="#" class="">
                    Shipping
                  </a>
                </li>
                <li class="pb-4">
                  <a href="#" class="">
                    FAQs
                  </a>
                </li>
              </ul>
            </div>
          </section>
        </section>

        <section class="flex flex-col">
          <h3 class="font-bold pb-8 text-[#7a3432] drop-shadow-lg">
            NEWSLETTER
          </h3>
          <input
            placeholder="email@example.com"
            className="bg-transparent mb-6 border-b border-black hover:border-red-500 outline-none "
          />
          <button
            className="w-100 h-70 bg-[#bd6961] text-white hover:bg-[#7a3432] hover:text-white
          transition-colors duration-500 ease-in-out hover:transition-delay-100 px-4 py-2 rounded-full"
          >
            Join Us
          </button>
        </section>
      </div>
      <div class="text-center text-gray-400 text-sm mt-9">
        Copyright © 2024 <span className="hover:text-red-600">AES</span> All
        rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
